import { Badge, Logo, PerchLogos } from '@perch-labs/shrike';
import { BackgroundColors } from '@perch-labs/shrike/dist/types/src/types';
import { Link } from '~/components/link';
import { OriginationSource } from '~/typings/graphql';
import { SPONSORED_SOLAR_LANDING_PAGE_URL, WEBSITE_URL } from '~/utils/constants';
import { HeaderWrapper, SubContainer } from './header.style';

export const Header = ({
  badge,
  backgroundColor,
  originationSource,
}: {
  badge?: string;
  backgroundColor?: BackgroundColors;
  originationSource?: OriginationSource;
}) => {
  const urlMap = {
    [OriginationSource.SponsoredSolar]: SPONSORED_SOLAR_LANDING_PAGE_URL,
  };
  const URL = urlMap[originationSource ?? ''] || WEBSITE_URL;
  return (
    <HeaderWrapper entity={originationSource}>
      {originationSource !== OriginationSource?.PerchEnergy ? (
        <>
          <Link
            color="primary"
            href={URL}
            openInNewTab
            display="flexbox"
            aria-label="Go to homepage"
          >
            <Logo scale={3} type="name" variant="dark" />
          </Link>
          {!!badge && (
            <SubContainer>
              <Badge backgroundColor={backgroundColor ?? 'accent2'}>{badge}</Badge>
            </SubContainer>
          )}
        </>
      ) : (
        <PerchLogos type="perchCommunity" width={120} height={40} />
      )}
    </HeaderWrapper>
  );
};
